export var buildPropertyNumberMessage = function (count, isMobile) {
    if (count === 1 && isMobile)
        return "1 propiedad";
    else if (count === 1 && !isMobile)
        return "1 propiedad coincide con tu b\u00FAsqueda";
    else if (count > 1 && isMobile)
        return count + " propiedades";
    return count + " propiedades coinciden con tu b\u00FAsqueda";
};
